export var PerformanceObserverEntryTypes = {
  LayoutShift: 'layout-shift',
  LongTask: 'longtask'
};